import { render, staticRenderFns } from "./PaymentMethodPage.vue?vue&type=template&id=b17e76a4&scoped=true&"
import script from "./PaymentMethodPage.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodPage.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodPage.vue?vue&type=style&index=0&id=b17e76a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17e76a4",
  null
  
)

export default component.exports